import React from "react"
import types from "prop-types"
import ContentBar from "shared/lists/ContentBar"
import TrackedFormDetails from "./TrackedFormDetails"

const AuthenticatedDetails = ({ className = "", tracksSubmissions }) => (
  <div className={className}>
    {
      tracksSubmissions ? (
        <TrackedFormDetails />
      ) : (
        <ContentBar
          description="This submission will remain anonymous and not be associated to your user account."
        />
      )
    }

  </div>
)

AuthenticatedDetails.propTypes = {
  className: types.string,
  tracksSubmissions: types.bool.isRequired,
}

export default AuthenticatedDetails
